module.exports = __webpack_public_path__ + "static/newscorp-logo-e1acadd2803a679bfd66823f63de5167.png";